<template lang="pug">
v-container.pa-4
  h2.my-2 Pessoas
  list(url='/people/search_person' title='Pessoas' attribute='people' listBy='name')
</template>

<script>
// import utils from '../utils/requests'
import List from '../components/List'

export default {
  components: {
    List
  }
}
</script>
